import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import { Close } from 'components/SvgIcons';

import './styles.scss';

const propTypes = {
    children: PropTypes.any,
    ariaHideApp: PropTypes.bool,
    className: PropTypes.bool,
    overlayClassName: PropTypes.bool,
    headerClass: PropTypes.bool,
    closeTimeoutMS: PropTypes.number,
    isOpen: PropTypes.bool,
    onAfterOpen: PropTypes.func,
    onRequestClose: PropTypes.func,
    shouldCloseOnEsc: PropTypes.bool,
    shouldCloseOnOverlayClick: PropTypes.bool,
    withCloseIcon: PropTypes.bool,
    contentLeft: PropTypes.func,
    contentLeftClassName: PropTypes.string,
    contentCenter: PropTypes.func,
    contentCenterClassName: PropTypes.string,
    contentRight: PropTypes.func,
    contentRightClassName: PropTypes.string,
};

class FullModalBlank extends PureComponent {
    state = {};

    renderClose = () => {
        const { withCloseIcon, onRequestClose } = this.props;

        if (!withCloseIcon || !onRequestClose) return false;

        return (
            <div className="fm-full-modal-blank__close" onClick={onRequestClose}>
                <Close color="$fmWhite" />
            </div>
        );
    };

    renderLeft = () => {
        const { contentLeft, contentLeftClassName } = this.props;

        if (!contentLeft) return null;

        let className = ['fm-full-modal-blank__left-container'];
        if (contentLeftClassName) className.push(contentLeftClassName);

        return <div className={className.join(' ')}>{contentLeft()}</div>;
    };

    renderCenter = () => {
        const { contentCenter, contentCenterClassName } = this.props;

        if (!contentCenter) return null;

        let className = ['fm-full-modal-blank__center-container'];
        if (contentCenterClassName) className.push(contentCenterClassName);

        return <div className={className.join(' ')}>{contentCenter()}</div>;
    };

    renderRight = () => {
        const { contentRight, contentRightClassName } = this.props;

        let className = ['fm-full-modal-blank__right-container'];
        if (contentRightClassName) className.push(contentRightClassName);

        return (
            <div className={className.join(' ')}>
                {contentRight && contentRight()}
                {this.renderClose()}
            </div>
        );
    };

    render() {
        const {
            children,
            ariaHideApp = false,
            className,
            overlayClassName,
            headerClass,
            closeTimeoutMS = 500,
            isOpen,
            onAfterOpen,
            onRequestClose,
            shouldCloseOnEsc = true,
            shouldCloseOnOverlayClick = true,
        } = this.props;

        const headerClassNames = ['fm-full-modal-blank__header'];
        if (headerClass) headerClassNames.push(headerClass);

        return (
            <Modal
                ariaHideApp={ariaHideApp}
                className={`fm-full-modal-blank ${className || ''}`}
                overlayClassName={`fm-full-modal-blank__overlay ${overlayClassName || ''}`}
                closeTimeoutMS={closeTimeoutMS}
                isOpen={isOpen}
                onAfterOpen={onAfterOpen}
                onRequestClose={onRequestClose}
                shouldCloseOnEsc={shouldCloseOnEsc}
                shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
            >
                <div className={headerClassNames.join(' ')}>
                    {this.renderLeft()}
                    {this.renderCenter()}
                    {this.renderRight()}
                </div>
                {children}
            </Modal>
        );
    }
}

FullModalBlank.propTypes = propTypes;

export default FullModalBlank;
